import { Component, EventEmitter, OnInit, Output, HostListener, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Auth, Storage } from 'aws-amplify';
import { TitleService } from 'src/app/services/title.service';
import { AuthService } from 'src/app/services/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalComponent } from 'src/app/shared/modal/modal.component';
import { NotificationsService } from 'src/app/services/notifications.service';
import { FormValidationService } from 'src/app/services/form-validation.service';
import { PasswordValidatorsService } from 'src/app/services/password-validators.service';
import { Subscription } from 'rxjs';
import { UsuariosService } from 'src/app/services/usuarios.service';
import { PermisosService } from 'src/app/services/permisos.service';
import { ServiciosProcesoService } from '../../services/servicios-proceso.service';
import { EmpresaService } from 'src/app/services/empresa.service';
import { ReceptorService } from 'src/app/services/receptor.service';
import { TopbarConstants } from './topbar-modal.constants';
import countries from 'src/app/util/countries';
import { Usuario } from '@noe/models/Usuario.model';
import { PersonalizacionService } from '@noe/services/personalizacion.service';
import { takeUntil } from 'rxjs/operators';
import { BaseUnsubscribe } from 'src/app/util/base-unsubscribe';
import { CompartirDatosService } from '@noe/services/compartirDatos.service';
import { NgxCopilotService } from 'ngx-copilot';
import { SharedService } from '@noe/services/shared.service';
import { FirmaRapida } from '@noe/models/FirmaRapida.model';
import { FirmaRapidaService } from '@noe/services/firma-rapida.service';
import { SharedCargarDocumentosService } from '@noe/services/sharedCargarDocumentos.service';
import { SharedAvatarService } from '@noe/services/sharedAvatar.service';
import { ModalFreeComponent } from '@noe/shared/modal-free/modal-free.component';
import { SharedActivarCargaDocumento } from '@noe/services/sharedActivarCargaDocumento.service';
import { SharedPlanService } from '@noe/services/sharedPlan.service';
import { NiubizService } from '@noe/services/apiniubiz.service';
import { SharedActivarTitle } from '@noe/services/sharedActivarTitle.service';
import { environment } from 'src/environments/environment';
import { MarketPlaceService } from 'src/app/services/marketplace.service';
import {v4 as uuidv4} from 'uuid';


declare let invocarPagoNiubiz :any;
declare let invocarAntifraude :any;
@Component({
  selector: 'app-topbar-modal',
  templateUrl: './topbar-modal.component.html',
  styleUrls: ['./topbar-modal.component.scss']
})
export class TopbarModalComponent extends BaseUnsubscribe implements OnInit {

  @ViewChild('passModal') passModal:ModalComponent
  @ViewChild('modalCambiarmeCuentaPago') modalCambiarmeCuentaPago:ModalComponent
  @ViewChild('modalConfirmarLogout') modalConfirmarLogout:ModalFreeComponent
  @ViewChild('modalLecturaTerminos') modalLecturaTerminos:ModalComponent
  @ViewChild('editarMiCuentaModal') editarMiCuentaModal:ModalComponent
  @ViewChild('modalCambiadeplan') modalCambiadeplan:ModalComponent
  @ViewChild('modalCargarDocumentos') modalCargarDocumentos:ModalComponent
  @ViewChild('modalBoletaFactura') modalBoletaFactura:ModalComponent
  @ViewChild('modalTyC') modalTyC:ModalComponent

  @HostListener('document:click') clickout():void {
    if (this.drop) this.drop = false
    if (this.profileDrop) this.profileDrop = false
    if (this.profileTraductor) this.profileTraductor = false;
  }

  passForm:FormGroup
  usuarioForm:FormGroup
  boletaForm:FormGroup
  facturaForm:FormGroup
  subscription: Subscription
  headPremium = TopbarConstants.HEAD_PREMIUM;
  bodyPremium = TopbarConstants.BODY_PREMIUM;

  tipoDocumentos:string[] = [
    'DNI',
    'CE',
    'PTP',
    'Pasaporte'
  ]

  tipoDocumentoBoleta:string[] = [
    'DNI',
    'Pasaporte',
    'CE'
  ]

  verAnual:boolean=true;
  verMensual:boolean=false;
  verProcesoPago:boolean=false;
  verDetallesPago:boolean=false;
  verInformacionTransferencia:boolean=false;
  pagoForm:FormGroup;
  tipoPlanCategoria:string='';
  checked:boolean=false;
  checkedPago:boolean=false;
  verAddonsDoc:boolean=false;
  verAddonsFirma:boolean=false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public title: TitleService,
    public authService: AuthService,
    public notify: NotificationsService,
    public fb: FormBuilder,
    public fv: FormValidationService,
    public validators: PasswordValidatorsService,
    public usuarioService: UsuariosService,
    public permisosService: PermisosService,
    public serviciosProcesoService: ServiciosProcesoService,
    public empresaService: EmpresaService,
    public receptorService: ReceptorService,
    private customService: PersonalizacionService,
    public compartirDatosService: CompartirDatosService,
    private copilot: NgxCopilotService,
    private sharedService: SharedService,
    public service: FirmaRapidaService,
    private sharedCargarDocumentosService: SharedCargarDocumentosService,
    private sharedAvatarService: SharedAvatarService,
    private sharedActivarCargaDocumento: SharedActivarCargaDocumento,
    private sharedPlanService: SharedPlanService,
    public niubizService:NiubizService,
    private sharedActivarTitle: SharedActivarTitle,
    private marketPlaceService: MarketPlaceService
  ) {
    super();
  }

  countries: any[] = [...countries]
  .sort((a, b) => a.es.localeCompare(b.es))
  .map((item) => {
    return {
      ...item,
      optionName: `${item.es} (${item.dial})`
    }
  });

  countriesPago: any[] = [...countries]
  .sort((a, b) => a.es.localeCompare(b.es))
  .map((item) => {
    return {
      ...item,
      optionName: `${item.es}`
    }
  });

  // sidebar:boolean = true
  @Output()
  toggleSidebar: EventEmitter<any> = new EventEmitter()
  @Output()
  toggleSidebarCollapse: EventEmitter<any> = new EventEmitter()
  private readonly defaultLogo = '../../../assets/img/logo-1.png';

  name:string
  profiles:string[]
  existeEmail:boolean=false
  crearLoading:boolean
  drop:boolean
  profileDrop:boolean
  profileTraductor: boolean
  empresaActiva:any
  empresas:any[] = []
  esGratuita:boolean

  twice:boolean = false
  sus:Subscription

  dataPassword:boolean = false
  dataPasswordDate:string

  logoSidebar: string = this.defaultLogo;
  sharedData: string;
  rutaAvatar:any
  verModalGracias: boolean = false;
  preview:string;
  selected: any;
  procesoRapidoForm:FormGroup;
  cargarLoading:boolean;
  docLoading:boolean;
  proceso:FirmaRapida;
  documentosProceso:any[] = [];
  loading: boolean = true;
  sharedDoc: boolean = false;
  sharedDataAvatar: boolean = false;
  loadingAvatar: boolean = false;
  sharedModalPlan: boolean = false;
  start:boolean = false
  tipoBoleta: boolean = false;
  tipoFactura: boolean = false;
  tipoTarjeta: boolean = false;
  tipoTransferencia: boolean = false;
  notificacionPagoAct: boolean = false;
  notificacionMantAct: boolean = false;
  notActTarjeta: boolean = false;
  notDocumentos: boolean = false;
  notMantenimiento: boolean = false;
  tipoDoc: string;
  tipoPago: string;
  dateLastSession:any = ''
  validarCheck: boolean = false;

  ngOnInit(): void {
    console.log('###INIIT TOPBAR MODAL')
    this.scriptNiubiz();
    this.obtenerPlanesModal();
    this.compartirDatosService.changeMessage(false);

    this.start = localStorage.getItem('AUTHSTART') === 'start'
    console.log(this.start)
    if (this.start) {
      this.crearRegistroSession()
      this.obteniendoDatos(localStorage.getItem('AUTHUSER'), localStorage.getItem('AUTHSUBDOMINIO'))
    }else{
      this.cargarEmpresaActiva();
    }
    this.listarSessionesUsuario()
  }

  abrirModalTyC(){
    this.modalTyC.open();
  }

  checkDeclarar(check:boolean){
    this.validarCheck = check;
    //console.log(this.validarCheck,'validarCheck');
  }

  crearRegistroSession(){
    let user = localStorage.getItem('AUTHUSER')
    this.receptorService.crearRegistroSession(user).subscribe( data => {
      console.log(data.response)
    }, error => {
      console.log("Ocurrio un error al registrar la session.")
    });
  }


  listarSessionesUsuario(){
    let user = localStorage.getItem('AUTHUSER')
    this.receptorService.listarSessionesUsuario(user).subscribe( data => {
      let nowDate = new Date
      if( data != null && data.length > 0){
        nowDate = data.length == 2 ? new Date(data[1].dateSession) : new Date(data[0].dateSession)
      }
      this.dateLastSession = nowDate.toLocaleString();
      console.log('## dateLastSession',this.dateLastSession)
    }, error => {
      console.log("Ocurrio un error al registrar la session.")
    });
  }

  checkBoleta(e) {
    this.tipoBoleta = e;
    this.tipoFactura = false;
    this.formBoleta();
    if(this.boletaForm && this.tipoBoleta) {
      this.limpiarModal();
      this.modalBoletaFactura.open();
    }
    console.log('checkBoleta', this.tipoBoleta);
  }

  checkFactura(e) {
    this.tipoFactura = e;
    this.tipoBoleta = false;
    this.formFactura();
    if(this.facturaForm && this.tipoFactura) {
      this.limpiarModal();
      this.modalBoletaFactura.open();
    }
    console.log('checkFactura', this.tipoFactura);
  }

  checkTarjeta(e) {
    this.tipoTarjeta = e;
    this.tipoTransferencia = false;
    console.log('checkTarjeta', this.tipoTarjeta);
  }

  checkTransferencia(e) {
    this.tipoTransferencia = e;
    this.tipoTarjeta = false;
    console.log('checkTransferencia', this.tipoTransferencia);
  }

  limpiarModal() {
    if(this.tipoBoleta) {
      this.boletaForm.setValue({
        //tipoDocumento: '',
        dni: '',
        email: ''
      })
    } else {
      this.facturaForm.setValue({
        ruc: '',
        email: ''
      })
    }
  }

  deshabilitarCheck() {
    this.checked=false;
    this.tipoBoleta=false;
    this.tipoFactura=false;
    this.tipoDoc = '';
    if(this.boletaForm) {
      this.boletaForm.setValue({
        dni: '',
        email: ''
      })
    } else {
      this.facturaForm.setValue({
        ruc: '',
        email: ''
      })
    }
  }

  formBoleta() {
    this.boletaForm = this.fb.group({
      //tipoDocumento:['', [Validators.required]],
      dni:['', [Validators.required, Validators.maxLength(12), Validators.minLength(8)]],
      email:['', [Validators.required, Validators.email]]
    })
  }

  formFactura() {
    this.facturaForm = this.fb.group({
      ruc:['', [Validators.required, Validators.maxLength(11), Validators.minLength(11)]],
      email:['', [Validators.required, Validators.email]]
    })
  }

  guardarDatosBoleta() {
    if (!this.boletaForm.valid) {
      return this.fv.validateForm(this.boletaForm)
    }

    const body: any = {
      //tipoDocumento: this.boletaForm.get('tipoDocumento').value,
      dni: this.boletaForm.get('dni').value,
      email: this.boletaForm.get('email').value
    }
    console.log(body, 'guardarDatosBoleta');

    this.modalBoletaFactura.close();
  }

  guardarDatosFactura() {
    if (!this.facturaForm.valid) {
      return this.fv.validateForm(this.facturaForm)
    }

    const body: any = {
      ruc: this.facturaForm.get('ruc').value,
      email: this.facturaForm.get('email').value
    }
    console.log(body, 'guardarDatosFactura');

    this.modalBoletaFactura.close();
  }

  cargarEmpresaActiva(){
    this.name = this.authService.obtenerNombres().join(' ')
    this.profiles = this.authService.obtenerPerfiles()
    this.empresas = this.authService.obtenerEmpresas()
    this.empresaActiva = this.empresas.find(e => e.id == this.authService.obtenerIdEmpresaActiva())
    this.esGratuita = this.authService.obtenerTipoCuenta() !== 'PAGO'
    this.rutaAvatar = 'assets/img/noe-free/avatar-default.jpg' //default

    this.sus = this.route.queryParams.subscribe(params => {
      if (!params.login && !this.twice) {
        this.empresaService.obtenerEmpresaActiva(this.authService.obtenerIdEmpresaActiva()).subscribe(data => {
          this.authService.guardarDataEmpresaActiva(data.find(c => c.id == this.authService.obtenerIdEmpresaActiva()))
        }, error => {
          console.log(error)
        })

        this.obtenerData();

      }

      this.twice = true
    })
    this.receptorService.datosFechaContraseña( this.authService.obtenerUsername(), this.authService.obtenerSubdominio()).subscribe(data => {
      if(data['formatDate'] != null){
        this.dataPassword = data['formatDate'];
        this.dataPasswordDate = data['numberDay'];
      }
    }, error => {
      console.log(error)
    });

    this.sharedTitle();
    this.sharedTitleActualizar();
    this.sharedAvatarActualizar();
    this.sharedPlanActualizar();

    this.pagoForm = this.fb.group({
      tipoTarjeta: [false],
      tipoTransferencia: [false],
      tipoBoleta: [false],
      tipoFactura: [false]
    })

    this.validarFormulario();
    this.obtenerNumeroExpediente();
    this.obtenerLimitePeso();
    this.sharedButtonActualizar();

    this.obtenerPlanesyAdicionales();
  }

  obteniendoDatos(username,subdomain){
    this.usuarioService.obtenerUsuario(username, subdomain).subscribe(data => {
      this.notificacionPagoAct = data.failedPayment == 1
      this.notActTarjeta = data.failedPayment == 1
      console.log('this.notificacionPagoAct',this.notificacionPagoAct)
      console.log('this.notActTarjeta',this.notActTarjeta)
      this.authService.guardarDatos(data, true)
      this.name = this.authService.obtenerNombres().join(' ')
      this.profiles = this.authService.obtenerPerfiles()
      this.rutaAvatar = 'assets/img/noe-free/avatar-default.jpg' //default

      this.sus = this.route.queryParams.subscribe(params => {
        if (!params.login && !this.twice) {
          this.empresaService.obtenerEmpresaActiva(this.authService.obtenerIdEmpresaActiva()).subscribe(data => {
            this.authService.guardarDataEmpresaActiva(data.find(c => c.id == this.authService.obtenerIdEmpresaActiva()))
            this.empresas = this.authService.obtenerEmpresas()
            this.empresaActiva = this.empresas.find(e => e.id == this.authService.obtenerIdEmpresaActiva())
            this.esGratuita = this.authService.obtenerTipoCuenta() !== 'PAGO'
            this.obtenerLimitePeso();
          }, error => {
            console.log(error)
          })

          this.obtenerData();

        }

        this.twice = true
      })
      this.receptorService.datosFechaContraseña( this.authService.obtenerUsername(), this.authService.obtenerSubdominio()).subscribe(data => {
        if(data['formatDate'] != null){
          this.dataPassword = data['formatDate'];
          this.dataPasswordDate = data['numberDay'];
        }
      }, error => {
        console.log(error)
      });

      this.sharedTitle();
      this.sharedTitleActualizar();
      this.sharedAvatarActualizar();
      this.sharedPlanActualizar();

      this.pagoForm = this.fb.group({
        tipoTarjeta: [false],
        tipoTransferencia: [false],
        tipoBoleta: [false],
        tipoFactura: [false]
      })

      this.validarFormulario();
      this.obtenerNumeroExpediente();

      this.sharedButtonActualizar();

      this.obtenerPlanesyAdicionales();
    }, error => {
      console.log(error)
    })
  }

  listaPaquetes:any [] = []
  obtenerPlanesModal(){
    this.marketPlaceService.listarOpcionesModalCompra(0).subscribe(
      data => {
        this.listaPaquetes = data
        console.log('### listaPaquetes',this.listaPaquetes)
      }, error => {
        console.log(error)
      })
  }

  lstPlans:any[] = []
  miPlanActual:any
  obtenerPlanesyAdicionales(){
    const body: any = {
      user: this.authService.obtenerUsername(),
      subdomain: this.authService.obtenerSubdominio(),
      idCompany : 0
    }
    this.marketPlaceService.listarPlanesPorUsuario(body).subscribe(data => {
      this.lstPlans = data;
      if(this.lstPlans.length > 0){
        this.miPlanActual = this.lstPlans.filter(d => d.checked == true)[0];
        // RQ Plan Personalizado
        if (this.miPlanActual == undefined || this.miPlanActual.length == 0){
          this.miPlanActual = {id: 4, name: 'Plan Personalizado'}
        }
      }
      console.log('miPlanActual',this.miPlanActual)
    })
  }

  planSeleccionado:any
  tipoPlanSeleccionado:any
  costoPlanSeleccionado:any
  costoTotalCompra:any = 0.00

  isPlanAnual:boolean
  //MONTHLY, QUARTERLY, BIANNUAL, ANNUAL
  capturarPlan(plan,anual){
    if(plan.id < this.miPlanActual.id){
      this.notify.info('No puede seleccionar un Plan inferior.')
      return;
    }
    this.planSeleccionado = plan
    let tipoSeleccionado = anual == true ? "anual" : "mensual"

    for( let type of plan.attributes.tipo_plan){
      if(type.tipo == tipoSeleccionado){
        this.tipoPlanSeleccionado = type
        this.costoPlanSeleccionado = type.costo
        this.costoTotalCompra = parseFloat(type.costo.toFixed(2))

        this.isPlanAnual = this.tipoPlanSeleccionado.tipo == 'anual'  ? true : false
      }
    }

    if(tipoSeleccionado == "anual"){
      this.verAnual = false;
    }else{
      this.verMensual = false;
    }
    this.verProcesoPago = true;
  }

  nombres:string=""
  esPlanPersonalizado: boolean = true
  obtenerData() {
    console.log("%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%55")
    this.loadingAvatar = true;
    this.usuarioService.obtenerUsuario(
      this.authService.obtenerUsername(),
      this.authService.obtenerSubdominio()).subscribe(data => {
      this.notificacionPagoAct = data.failedPayment == 1
      this.notActTarjeta = data.failedPayment == 1
      console.log('this.notificacionPagoAct',this.notificacionPagoAct)
      console.log('this.notActTarjeta',this.notActTarjeta)
      this.authService.guardarDatos(data, true)
      this.permisosService.setOpciones()
      this.profiles = this.authService.obtenerPerfiles()
      this.obtenerAvatarUsuario(data.routeAvatar)
      this.loadingAvatar = false;
      this.nombres = data.name+" "+data.surname
      if (data.attributes.plan.id < 4){
        this.esPlanPersonalizado = false;
      }
      console.log("pintameeee",data)
    }, error => {
      console.log(error)
    })
  }

  sharedAvatarActualizar() {
    console.log("///////////////////////////////////////////////")
    this.sharedAvatarService.sharedData$
    .subscribe(sharedDataAvatar => {
      this.sharedDataAvatar = sharedDataAvatar;
      this.obtenerData();
    });
  }

  sharedPlanActualizar() {
    this.sharedPlanService.sharedData$
    .subscribe(sharedDataPlan => {
      this.sharedModalPlan = sharedDataPlan;
      this.openModalCambiadeplan();
    });
  }

  sharedPlan() {
    this.sharedModalPlan = false;
    this.sharedPlanService.setData(this.sharedModalPlan);
  }

  activarCargaDocumento:boolean

  sharedButtonActualizar() {
    this.sharedActivarCargaDocumento.sharedActivar$
    .subscribe(sharedActivate =>  {
      this.activarCargaDocumento = sharedActivate;
      this.sharedActivarTitle.setData(this.sharedData);
      console.log('activarCargaDocumento', this.activarCargaDocumento);
    });
  }

  sharedTitleActualizar() {
    this.sharedActivarTitle.sharedActivar$
    .subscribe(sharedActivateTitle =>  {
      this.sharedTitleSession();
    });
  }

  validarFormulario(){
    this.procesoRapidoForm = this.fb.group({
      idDocumentType: ['Genérico', [Validators.required]],
      idProcessType: ['Firma de Documentos', [Validators.required]],
      statusExpedientNumber: [true, [Validators.required]],
      expedientNumber: ['', [Validators.required]],
      incremental: ['']
    })
  }

  obtenerNumeroExpediente() {
    this.service.obtenerNumeroExpediente(
      this.authService.obtenerIdEmpresaActiva(),
      this.authService.obtenerSubdominio(),
      this.authService.obtenerUsername()
    ).subscribe(data => {
      this.procesoRapidoForm.get('expedientNumber').setValue(data.expedient_number)
      this.procesoRapidoForm.get('incremental').setValue(data.incremental)
    }, error => {
      console.log(error)
    })
  }

  crearProceso() {

    // this.loadingText = 'Creando Proceso'
     this.cargarLoading = true
     this.statusLoading = true
     const data = {
       expedientNumber: this.procesoRapidoForm.get('expedientNumber').value,
       statusExpedientNumber: this.procesoRapidoForm.get('statusExpedientNumber').value,
       incremental: this.procesoRapidoForm.get('incremental').value
     }

     this.cargarLoading = true
     this.service.crearProceso(
       this.authService.obtenerIdEmpresaActiva(),
       this.authService.obtenerSubdominio(),
       this.authService.obtenerUsername(),
       data
     ).subscribe(data => {

       this.proceso = {id:data['response']['idProcess']}
       this.upload()

     }, error => {
       this.cargarLoading = false
       if (error.status === 409) this.notify.error(error.error.response)
       else this.notify.error('Hubo un problema al crear el proceso')

       console.log(error)
       this.statusLoading = false
      // this.loadingText = ''
     })
   }

   uploadList:File[] = []
   async handleUpload(files:any[]) {
     this.uploadList = files
   }

   archivos:{name:string, path:string, id:string}[]
   async upload(){
     const archivos:{name:string, path:string, id:string}[] = []
     const today:Date = new Date()
     for (const f of this.uploadList) {
       const key:string = `${this.authService.obtenerRucEmpresaActiva()}/documentos_digitales/${today.getFullYear()}/${this.proceso.id}/documentos_cargados/${f.name}`
       try {
         const idCompany = this.authService.obtenerIdEmpresaActiva()
         const ruc = this.authService.obtenerRucEmpresaActiva()
         const subdomain = this.authService.obtenerSubdominio()
         const idGroupCompany = this.authService.obtenerIdGrupoEmpresarial()
         /** no agregamos la razon social por carateres espciales en si las tildes */
         await Storage.put(key, f, {
           tagging: 'idCompany='+idCompany+'&ruc='+ruc+'&subdomain='+subdomain+'&idGroupCompany='+idGroupCompany
         })

         const file = {name:f.name, path:`public/${key}`, id:''}
         archivos.push(file)

       } catch (error) {
         this.notify.error('Hubo un problema al cargar sus archivos')
         console.log(error)
         this.statusLoading = false
       }
     }
     this.archivos = archivos
     this.agregarDocumentos()
   }

   statusLoading:boolean = false
   async agregarDocumentos() {
     this.loading = true
    // this.errorLoading = false

     this.docLoading = true
   ///  this.loadingText = 'Actualizando Proceso'
     const data:FirmaRapida = {
       idProcess: this.proceso.id,
       routeFile: `public/${this.authService.obtenerRucEmpresaActiva()}/documentos_digitales/${new Date().getFullYear()}/${this.proceso.id}`,
       files: this.archivos,
     }
     this.service.cargar(
       this.authService.obtenerIdEmpresaActiva(),
       this.authService.obtenerSubdominio(),
       this.authService.obtenerUsername(),
       data
     ).subscribe(data => {
       this.loading = false
       //this.buildBody(null,1,20,null)
       this.sharedDocs();
       this.sharedDocsService();
       this.statusLoading = false;
       this.closeModalCargarDocumentos();
     }, error => {
       console.log(error)
     //  this.loadingText = 'Error: no se actualizó el proceso'
       this.loading = false
     //  this.errorLoading = true
       this.docLoading = false
       this.statusLoading = false
     })
   }

   removeFile(event:any){
     const files = [...this.uploadList]
     files.splice(files.indexOf(event), 1);
     this.uploadList = files
     this.preview = this.uploadList.length === 0 ? null : 'true'
  }

  limitePeso:number
  obtenerLimitePeso() {
    const valor = this.authService.obtenerLimitePeso()
    if (!valor) return
    this.limitePeso = parseInt(valor.split(' ')[0])
  }

  fecha: any;
  setSelectedPais(event){
    this.fecha = event.target.value
    console.log(this.fecha,'fecha')
  }

  openModalCargarDocumentos() {
    this.modalCargarDocumentos.open();
  }

  closeModalCargarDocumentos() {
    this.modalCargarDocumentos.close();
  }

  setPreview(base:string) {
    this.preview = base;
  }

  selectBoton(item, $event) {
    this.selected = (this.selected === item ? null : item);
    $event ? $event.stopPropagation() : null;
  }

  isActiveBoton(item) {
    return this.selected === item;
  }

  /*detallePago() {
    const nationalityPais = this.pagoForm.get('pais').value;
    const nationalityProvincia = this.pagoForm.get('provincia').value;
    const pais = countries.find((item) => item.code === nationalityPais)?.code;
    const provincia = countries.find((item) => item.code === nationalityProvincia)?.code;

    let detallePago: any = {
      tipoTarjeta: this.pagoForm.get('tipoTarjeta').value,
      tipoTransferencia: this.pagoForm.get('tipoTarjeta').value,
      mes: this.pagoForm.get('mes').value,
      anio: this.pagoForm.get('anio').value,
      cvv: this.pagoForm.get('cvv').value,
      nombre: this.pagoForm.get('nombre').value,
      apellido: this.pagoForm.get('apellido').value,
      correo: this.pagoForm.get('correo').value,
      pais: pais,
      provincia: provincia,
      direccion: this.pagoForm.get('direccion').value,
      tipoPago: this.pagoForm.get('tipoPago').value
    }

    console.log('detallePago', detallePago)

    this.verDetallesPago = false;
    this.verModalGracias = true;
  }*/

  openModalCambiadeplan() {
    this.modalCambiadeplan.open();
    this.verAnual = true;
    this.tipoPlanCategoria = 'anual'
  }

  closeModalCambiadeplan() {
    this.modalCambiadeplan.close();
    this.verModalGracias = false
    this.verDetallesPago = false
    this.verProcesoPago = false
    this.verMensual = false;
    this.verAnual = true;
    this.buttonPay = false;
    this.validarCheck = false;
    this.checked=false;
    this.checkedPago=false;
    this.verInformacionTransferencia = false;
    this.verAddonsDoc = false;
    this.verAddonsFirma = false;

    this.paquetesAdicionales = []
    this.listaPaquetes.forEach(t => { t.checked = false})
    this.tipoPlanCategoria = ''

    localStorage.removeItem('DATA_PAYMENT') //Evitar Modal de Compra
  }

  sharedDocs() {
    this.router.navigate(['/mis-documentos/documentos']);
    this.sharedData = 'Documentos';
    this.sharedService.setData(this.sharedData);
    this.sharedCargarDocumentosService.sharedData$
    .subscribe(sharedDataDocs => this.sharedDoc = sharedDataDocs);
  }

  sharedPerfil() {
    this.sharedData = 'Mi Perfil';
    this.sharedService.setData(this.sharedData);
  }

  sharedDocsService() {
    setTimeout(() => {
      this.sharedDoc = true;
      this.sharedCargarDocumentosService.setData(this.sharedDoc);
      console.log(this.sharedDoc,'sharedDocPadre');
    }, 800)
  }

  sharedTitle() {
    this.sharedService.sharedData$
    .subscribe(sharedData => this.sharedData = sharedData);
  }

  code_child: string;
  sharedTitleSession() {
    this.obtenerData();
    console.log(this.router.url, 'ruta');
    if(this.router.url == "/") {
        this.sharedData = null;
        this.code_child = '0000006';
        this.sharedService.setData(this.sharedData);
    }
    if(this.router.url == "/mis-documentos/documentos") {
      this.sharedData = 'Documentos';
      this.code_child = '0000701';
      console.log(this.code_child, 'code_child');
      this.sharedService.setData(this.sharedData);
    }
    if(this.router.url == "/mis-documentos/papelera") {
      this.sharedData = 'Papelera';
      this.code_child = '0000702';
      console.log(this.code_child, 'code_child');
      this.sharedService.setData(this.sharedData);
    }
    if(this.router.url == "/contactos/lista-de-contactos") {
      this.sharedData = 'Lista de contactos';
      this.code_child = '0000801';
      this.sharedService.setData(this.sharedData);
    }
    if(this.router.url == "/configuraciones/mi-perfil") {
      this.sharedData = 'Mi perfil';
      this.code_child = '0000901';
      this.sharedService.setData(this.sharedData);
    }
    if(this.router.url == "/configuraciones/notificaciones") {
      this.sharedData = 'Notificaciones';
      this.code_child = '0000902';
      this.sharedService.setData(this.sharedData);
    }
    if(this.router.url == "/configuraciones/r%C3%BAbrica") {
      this.sharedData = 'Rúbrica';
      this.code_child = '0000903';
      this.sharedService.setData(this.sharedData);
    }
    if(this.router.url == "/configuraciones/certificado-digital") {
      this.sharedData = 'Certificado digital';
      this.code_child = '0000904';
      this.sharedService.setData(this.sharedData);
    }
    if(this.router.url == "/configuraciones/facturaci%C3%B3n") {
      this.sharedData = 'Facturación';
      this.code_child = '0000905';
      this.sharedService.setData(this.sharedData);
    }
    if(this.router.url == "/market") {
      this.sharedData = 'Market';
      this.code_child = '0000010';
      this.sharedService.setData(this.sharedData);
    }
    if(this.router.url == "/usuarios-free") {
      this.sharedData = 'Bandeja de usuarios';
      this.code_child = '0000011';
      this.sharedService.setData(this.sharedData);
    }
  }

  async obtenerAvatarUsuario(value:any){
    console.log('value topbar avatar',value)
    if (value != null && value != '') {
      let src = await Storage.get(value, {customPrefix: {public: ''}})
      //console.log(src)
      this.rutaAvatar = src
    }else{
      this.rutaAvatar = 'assets/img/noe-free/avatar-default.jpg'
    }
  }

  /*Re initialize in specify step*/
  initPosition(stepNumber: any) {
    this.copilot.checkInit(stepNumber);
  }

  /*Initialize*/
  init() {
    this.copilot.checkInit();
  }

  /*Next Step*/
  siguiente(stepNumber: any) {
    this.copilot.next(stepNumber);
  }

  /*Finish*/
  omitir() {
    this.copilot.removeWrapper();
  }

  closeDrop() {
    this.profileTraductor = false;
    this.profileDrop = false;
  }

  closeProfileDrop() {
    this.profileTraductor = false;
    this.drop = false;
  }

  closeProfileTraductor() {
    this.profileDrop = false;
    this.drop = false;
  }

  scriptTraductor() {
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    document.body.appendChild(script);
  }

  scriptTraductorStyle() {
    let jq = document.createElement("script");
    jq.type = "text/javascript";
    jq.src = "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.1.1/jquery.min.js";
    document.body.appendChild(jq);
  }

  scriptNiubiz() {
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = environment.scriptNiubiz;
    document.body.appendChild(script);
    console.log('script niubiz',script)
  }

  listenCustomImages(): void {
    this.customService.listarImagenesPersonalizacionLogeado(
      this.authService.obtenerSubdominio() , this.authService.obtenerIdEmpresaActiva()
    )
    .pipe(takeUntil(this.destroy$))
    .subscribe((response: any) => {
      const { logoWeb } = response;

      this.logoSidebar = logoWeb
        //? logoWeb
        ? this.defaultLogo
        : this.defaultLogo;
    });
  }

  seleccionarEmpresaActiva(empresa) {
    this.authService.guardarEmpresaActiva(empresa)
    location.reload()
  }

  toggle(event: MouseEvent) {
    event.stopPropagation()
    this.toggleSidebar.emit()
  }

  toggleCollapse(event: MouseEvent) {
    event.stopPropagation()
    this.toggleSidebar.emit()
  }

  async logout() {
    this.sus.unsubscribe();
    localStorage.clear();
    await Auth.signOut({ global: true });
    this.router.navigate(['/login']);
  }


  abrirModalConfirmarSalir(){
    this.modalConfirmarLogout.open()
    this.compartirDatosService.changeMessage(true);

  }
  confirmarSalir(){
    this.recordatorioFirmaDocumento()
    this.logout()
    this.compartirDatosService.changeMessage(false);
  }

  recordatorioFirmaDocumento(){
    const data:any={
      idCompany:this.authService.obtenerIdEmpresaActiva(),
      user:this.authService.obtenerUsername(),
      subdomain:this.authService.obtenerSubdominio()
    }
    console.log(data)
    this.serviciosProcesoService.sendRecoratorySign(data).subscribe(data => {
      console.log(data)
    }, error => {
      console.log(error)
    })
  }

  cancelarSalir(){
    this.modalConfirmarLogout.close()
    this.compartirDatosService.changeMessage(false);
  }

  valorBloquear:boolean
  enviarValor: boolean
  abrirModalLecturaTerminos(){
    this.modalLecturaTerminos.open()
    this.compartirDatosService.changeMessage(true);
  }

  initChangePass() {
    this.compartirDatosService.changeMessage(true);
    if (!this.passForm) {
      const passwordValidators = this.validators.set()
      this.passForm = this.fb.group({
        oldPass: ['', [Validators.required, Validators.minLength(6)]],
        password: ['', passwordValidators],
        confirm: ['', [Validators.required]]
      }, { validators: this.checkPasswords })
    }
    this.passModal.open()
  }


  checkPasswords(group: FormGroup) {
    let pass = group.get('password').value;
    let confirmPass = group.get('confirm').value;
    return pass === confirmPass ? null : { mismatch: true }
  }

  pLoading:boolean
  // Cambiar contraseña
  async changePassword(e) {

    e.preventDefault()

    if (this.pLoading) return

    if (this.passForm.invalid) {
      return this.fv.validateForm(this.passForm)
    }

    this.pLoading = true

    try {
      const user = await Auth.currentAuthenticatedUser()
      const result = await Auth.changePassword(user, this.passForm.get('oldPass').value, this.passForm.get('password').value);

      if (result === 'SUCCESS') {
        try{
          this.receptorService.actualizarFechaContraseña(this.authService.obtenerUsername(), this.authService.obtenerSubdominio()).subscribe(
            data => {
              console.log('Fecha Contraseña Actualizada')
          })
          this.pLoading = false
          this.passModal.close()
          this.passForm.reset()
          this.compartirDatosService.changeMessage(false);
          this.notify.success('Contraseña cambiada con éxito')
        }catch(error){
          console.log('Hubo un problema al actualizar la fecha')
        }

      } else {
        this.notify.error('Hubo un problema al procesar la solicitud')
      }

    } catch (error) {
      this.notify.error('Hubo un problema al realizar la petición')
    }

    this.pLoading = false
  }

  modalCambiarmeCuentaPagoLoading:boolean
  solicitarPremium(){
    this.modalCambiarmeCuentaPago.open()
  }

  aceptarCambiarmeCuentaPago(){
    this.modalCambiarmeCuentaPagoLoading = true
    const data:any={
      idCompany:this.authService.obtenerIdEmpresaActiva(),
      user:this.authService.obtenerUsername(),
      subdomain:this.authService.obtenerSubdominio()
    }
    this.serviciosProcesoService.enviarCorreoContactarme(data).subscribe(data => {
      this.notify.success("Se envió la solicitud correctamente.")
      this.modalCambiarmeCuentaPagoLoading = false
      this.modalCambiarmeCuentaPago.close()
      //this.modalContactarCuentaFreeLoading = false
    }, error => {
      this.notify.error(error.error.response)
      //this.modalContactarCuentaFreeLoading = false
    })

  }

   usuarioGuardado: Usuario
  onUpdateUser(): void {
    this.compartirDatosService.changeMessage(true);
    const username = this.authService.obtenerUsername();

    this.usuarioService.obtenerUsuario(username, this.authService.obtenerSubdominio()).subscribe(data => {

      console.log("DATA USUARIOS:" , data)
      this.usuarioGuardado = data

      const countryCode = countries.find((item) => item.code === data.nationalType)?.dial;
      if (!this.usuarioForm) {
        this.usuarioForm = this.fb.group({
          name:[data.surname, [Validators.required, Validators.minLength(2)]],
          paternalSurname:[data.surname, [Validators.required, Validators.minLength(2)]],
          maternalSurname:[data.surname, [Validators.required, Validators.minLength(2)]],
          identityType:[data.identityType, [Validators.required]],
          identityNumber:[data.identityNumber, [Validators.required, Validators.maxLength(10), Validators.minLength(8)]],
          email:[data.email, [Validators.required, Validators.email]],
          phoneNumber: [data.phoneNumber.slice(countryCode.length), [Validators.required, Validators.minLength(9),Validators.maxLength(9)]],
          nationalType: [data.nationalType, [Validators.required]],
          firmasType: [data.desc_tipos_firmas ?data.desc_tipos_firmas:[]],
          companys: [data.companys, [Validators.required]],
          editSignigProcess: [JSON.parse(data.attributes?.editar_proceso_firma.toLowerCase()) || false],
          enableSignigProcess: [JSON.parse(data.attributes?.desactivar_proceso_firma.toLowerCase()) || false],
          office: [data.attributes.oficina],
          idCompany : this.authService.obtenerIdEmpresaActiva()
        })
      }

    }, error => {
      console.log(error)
    })
    this.editarMiCuentaModal.open()
  }

  cerrarModalEditarCuenta(){
    this.compartirDatosService.changeMessage(false);
    this.editarMiCuentaModal.close()
  }

  handleSubmit(event?:any) {
    const usuario: Usuario = {...this.usuarioForm.value};
    usuario.login = this.usuarioForm.get('identityNumber').value
    const nationality = this.usuarioForm.get('nationalType').value;
    const countryCode = countries.find((item) => item.code === nationality)?.dial;
    usuario.phoneNumber = countryCode + this.usuarioForm.get('phoneNumber').value;

    const regex:RegExp = new RegExp(' ', 'g')
    usuario.phoneNumber = usuario.phoneNumber.replace(regex, '');
    usuario.document_type = this.usuarioGuardado.attributes.tipos_documentos
    usuario.document_visado = this.usuarioGuardado.attributes.documentos_visado
    usuario.companys=JSON.stringify(this.usuarioGuardado.companys)
    usuario.idCompany = this.authService.obtenerIdEmpresaActiva()
    usuario.editSignigProcess = this.usuarioGuardado.attributes.editar_proceso_firma == "False" ? false : true
    usuario.idProfile=this.usuarioGuardado.idProfile
    usuario.idTipoFirma=JSON.stringify(this.usuarioGuardado.attributes.tipos_firmas)
    usuario.role = this.usuarioGuardado.attributes.roles
    usuario.subdomain = this.usuarioGuardado.subdomain


    console.log("DATOS EDITAR MI CUENTA:", usuario)

    this.crearLoading = true;
    this.usuarioService.actualizarUsuario(
      usuario.email,
      this.authService.obtenerSubdominio(),
      usuario
    ).subscribe(data => {

      this.notify.success('Edición exitosa')
      this.editarMiCuentaModal.close()
      this.compartirDatosService.changeMessage(false);
    }, error => {
      this.crearLoading = false
      if (error.status === 409) this.existeEmail=true
      else this.notify.error('No se pudo editar')
    })


  }

  validarTipoPlan(){
    if(this.planSeleccionado.id != 1){
      this.generarSessionNiubiz();
    }
  }

  merchantIdNiubiz:any
  tokenNiubizSession:any=""
  purchasenumber:any = ""
  montoPago:any = ""
  buttonPay:boolean = false
  generarSessionNiubiz() {
    this.verProcesoPago=false
    this.verDetallesPago=true
    //this.montoPago = this.costoTotalCompra + '.00'
    this.montoPago = parseFloat(this.costoTotalCompra.toFixed(2));

    //Almacenar datos de compra de plan para modal
    this.guardarDatosPlanPayment();

    //Object : token session - niubiz
    const body: any={
      idCompany: parseInt(this.authService.obtenerIdEmpresaActiva()),
      subdomain: this.authService.obtenerSubdominio(),
      email: this.authService.obtenerUsername(),
      monto: this.montoPago,
      dataPayment: this.dataPayment
    }
    //console.log('body niubiz', body)
    //this.invocarAntifraude()
    this.niubizService.obtenerNuevaSesion(body).subscribe(data => {
      if(data.sessionKey != null){
        this.tokenNiubizSession = data.sessionKey
        this.purchasenumber = data.purchasenumber
        this.merchantIdNiubiz = data.merchantId
        this.buttonPay = true;
      }else{
        this.notify.info('Hubo un problema, intentelo mas tarde')
      }
    }, error => {
      console.log(error)
      this.notify.error('Ocurrio un error, intentelo mas tarde.')
    })

  }

  dataPayment:any
  guardarDatosPlanPayment(){
    delete this.tipoPlanSeleccionado.options.nombres_firmas; //Evitar error al crear la transaccion por /n
    const planSeleccionado:any = {
      id : this.planSeleccionado.id,
      name: this.planSeleccionado.name,
      attributes : this.tipoPlanSeleccionado
    }

    //Almacenar datos de compra de plan para modal
    this.dataPayment = {
      idPlanAnterior : this.miPlanActual.id,
      planAnterior : this.miPlanActual.name,
      planSeleccionado : planSeleccionado,
      adicionales: this.paquetesAdicionales,
      tipoPayment: 'plan'
    }

    localStorage.setItem('DATA_PAYMENT',JSON.stringify(this.dataPayment))
  }

  // INVOCANDO PAGO NIUBIZ
  invocarPagoNiubiz() {
    console.log('ingresando invocarPagoNiubiz')
    this.generarDatosRecibo();
    this.generarDatosNiubiz();
    console.log('this.dataNiubiz', this.dataNiubiz)
    invocarPagoNiubiz(this.dataNiubiz);
  }

  //INVOCANDO Niubiz Antifraude
  uuidAntifraud:any
  invocarAntifraude() {
    if(this.tipoTransferencia) {
      this.verInformacionTransferencia = true;
      this.generarDatosRecibo();
    } else {
      console.log('ingresando invocarAntifraude')
      this.uuidAntifraud = uuidv4();
      console.log('Your UUID is: ' , this.uuidAntifraud);
      invocarAntifraude(this.uuidAntifraud);
      setTimeout(() => {
        console.log('--final timeout')
        this.invocarPagoNiubiz();
      }, 3000);
    }
  }

  dataRecibo:any
  generarDatosRecibo() {
    let emailRecibo = this.authService.obtenerUsername();
    let documentRecibo = this.authService.obtenerDocumento();
    //let tipoDocumentoRecibo

    if(this.tipoTarjeta){
      this.tipoPago = 'TARJETA';
    }
    if(this.tipoTransferencia) {
      this.tipoPago = 'TRANSFERENCIA';
    }

    if(this.tipoBoleta){
      //tipoDocumentoRecibo = this.boletaForm.get('tipoDocumento').value;
      //emailRecibo = this.boletaForm.get('email').value != '' ? this.boletaForm.get('email').value : this.authService.obtenerUsername();
      //documentRecibo = this.boletaForm.get('dni').value != '' ? this.boletaForm.get('dni').value : this.authService.obtenerDocumento();
      emailRecibo = this.boletaForm.get('email').value;
      documentRecibo = this.boletaForm.get('dni').value;
      this.tipoDoc = 'BOLETA';
    }else if((this.tipoFactura)){
      //emailRecibo = this.facturaForm.get('email').value != '' ? this.facturaForm.get('email').value : this.authService.obtenerUsername();
      //documentRecibo = this.facturaForm.get('ruc').value != '' ? this.facturaForm.get('ruc').value : this.authService.obtenerDocumento();
      emailRecibo = this.facturaForm.get('email').value;
      documentRecibo = this.facturaForm.get('ruc').value;
      this.tipoDoc = 'FACTURA';
    }

    /*if(this.tipoBoleta || (!this.tipoBoleta && !this.tipoFactura) || (this.tipoFactura && this.facturaForm.get('ruc').value == '' && this.facturaForm.get('email').value == '') || (this.tipoFactura && this.facturaForm.get('ruc').value == '')) {
      this.tipoDoc = 'BOLETA';
    }

    if((this.tipoFactura && !(this.facturaForm.get('ruc').value == '') && this.facturaForm.get('email').value == '') || (this.tipoFactura && !(this.facturaForm.get('ruc').value == ''))) {
      this.tipoDoc = 'FACTURA';
    }*/

    this.dataRecibo = {
      typePay: this.tipoPago,
      type: this.tipoDoc, //Añadiendo el tipo de recibo
      //tipoDocumento: this.tipoDoc == 'BOLETA' ? tipoDocumentoRecibo : "",
      email: emailRecibo,
      document: documentRecibo
    }
    console.log('recibo',this.dataRecibo)
  }

  dataNiubiz:any
  generarDatosNiubiz(){
    const actionResponseURL = `${environment.apiCore}/niubiz_tokenizacion` + '?purchase=' + this.purchasenumber + '&type=' + this.dataRecibo.type + '&email=' + this.dataRecibo.email + '&document=' + this.dataRecibo.document + '&uuidAntifraud=' + this.uuidAntifraud

    const timeoutURL = 'https://' + this.authService.obtenerSubdominio() + '.noe.pe';
    let logoApp = environment.reporteReplace + 'images-notifications/logo-noe-black.png'
    let nombresUser = this.authService.obtenerNombres();

    this.dataNiubiz = {
      token : this.tokenNiubizSession,
      purchasenumber :  this.purchasenumber,
      merchantId : this.merchantIdNiubiz,
      tokenUser : this.authService.obtenerDocumento(),
      amount : this.montoPago,
      nameUser : nombresUser[0],
      surnameUser: nombresUser[1],
      emailUser : this.authService.obtenerUsername(),
      urlResponse : actionResponseURL,
      urlTimeout: timeoutURL,
      logo: logoApp
    }
  }
  paquetesAdicionales:any[] = []
  agregarPaquete(paq){
    //let nwcosto = this.isPlanAnual ? paq.cost * 10 : paq.cost
    let nwcosto = this.isPlanAnual ? parseFloat((paq.cost  * 10).toFixed(2)) : parseFloat(paq.cost.toFixed(2));
    const npaq = {id:paq.id,name:paq.name, tipo:paq.category, costo: nwcosto, cantidad:paq.cantidad, costoMarket: nwcosto}
    this.listaPaquetes.forEach(t => { if (t.id === paq.id) t.checked = true})
    this.paquetesAdicionales.push(npaq)
    this.costoTotalCompra  = parseFloat((this.costoTotalCompra + npaq.costo).toFixed(2));
    console.log('this.paquetesAdicionales',this.paquetesAdicionales)
  }
  quitarPaquete(paq){
    //let nwcosto = this.isPlanAnual ? paq.cost * 10 : paq.cost
    let nwcosto = this.isPlanAnual ? parseFloat((paq.cost  * 10).toFixed(2)) : parseFloat(paq.cost.toFixed(2));
    const npaq = {id:paq.id,name:paq.name, tipo:paq.category, costo: nwcosto, cantidad:paq.cantidad, costoMarket: nwcosto}
    this.listaPaquetes.forEach(t => { if (t.id === paq.id) t.checked = false})
    this.paquetesAdicionales = this.paquetesAdicionales.filter(p => p.id !== npaq.id)
    this.costoTotalCompra  = parseFloat((this.costoTotalCompra - npaq.costo).toFixed(2));
    console.log('this.paquetesAdicionales',this.paquetesAdicionales)
  }
}
